import { Flex, Typography } from 'front-commons/ds';
import { ThemeColorsTypes } from 'front-commons/ds/core/shared/interfaces';
import { contactInfo } from 'front-commons/constants/contactInfo';
import { TypographyProps } from 'front-commons/ds/components/Typography/interfaces';
import { FlexProps } from 'front-commons/ds/components/Flex/interfaces';
import { Icon, IconOwnProps } from 'hype-ds';

interface ContactUsProps {
	color?: ThemeColorsTypes;
	iconsColor?: ThemeColorsTypes;
	phoneColor?: ThemeColorsTypes;
	phoneUnderline?: boolean;
	hide?: Array<'openingHours' | 'phones' | 'email'>;
	alignItems?: ResponsiveTypes<'center' | 'flex-start' | 'flex-end'>;
	override?: {
		openingHours?: React.ReactNode;
		phones?: React.ReactNode;
		email?: React.ReactNode;
	};
	mobilePhoneAdaptation?: boolean;
	iconProps?: Partial<IconOwnProps>;
	containerProps?: Partial<FlexProps>;
	typographyProps?: Partial<TypographyProps>;
	phoneContainerProps?: Partial<FlexProps>;
}

export default function ContactUs({
	override,
	color,
	iconsColor = color,
	phoneColor = color,
	phoneUnderline,
	hide,
	alignItems,
	mobilePhoneAdaptation,

	iconProps,
	containerProps,
	typographyProps,
	phoneContainerProps,
}: ContactUsProps) {
	const variant = phoneUnderline ? 'Paragraph/Underline' : undefined;
	const adapt = {
		phoneContainerDirection: mobilePhoneAdaptation ? { small: 'column', medium: 'row' } : 'row',
		phoneSeparator: mobilePhoneAdaptation
			? undefined
			: { padding: '0 0 0 16px', border: phoneContainerProps?.border || '1px solid' },
	};

	return (
		<Flex alignItems={alignItems} direction="column" gap="16px" {...containerProps}>
			{!hide?.includes('openingHours') && (
				// @ts-expect-error
				<Typography color={color} style={{ display: 'flex', gap: '8px', alignItems: 'center' }} {...typographyProps}>
					<Icon color={iconsColor} name="schedule" {...iconProps} />
					{override?.['openingHours'] || contactInfo.OPENING_HOURS}
				</Typography>
			)}

			{!hide?.includes('phones') && (
				<Flex gap="16px" direction={adapt.phoneContainerDirection as any} {...phoneContainerProps}>
					{override?.['phones'] || (
						<>
							<Flex gap="8px" alignItems="center" as="a" href={contactInfo.WHATS_APP_LINK}>
								<Icon color={iconsColor} name="whatsapp" {...iconProps} />
								{/* @ts-expect-error */}
								<Typography variant={variant} color={phoneColor} {...typographyProps}>
									{contactInfo.WHATS_APP_MASKED}
								</Typography>
							</Flex>
							<Flex gap="16px" {...adapt.phoneSeparator} borderWidth="0 0 0 1px" borderColor={color}>
								<Flex gap="8px" alignItems="center" as="a" href={contactInfo.PHONE_LINK}>
									<Icon color={iconsColor} name="call" {...iconProps} />
									{/* @ts-expect-error */}
									<Typography variant={variant} color={phoneColor} {...typographyProps}>
										{contactInfo.PHONE_MASKED}
									</Typography>
								</Flex>
							</Flex>
						</>
					)}
				</Flex>
			)}

			{!hide?.includes('email') && (
				<Typography
					// @ts-expect-error
					color={color}
					as="a"
					href={contactInfo.EMAIL_LINK}
					style={{ display: 'flex', gap: '8px', alignItems: 'center' }}
					{...typographyProps}
				>
					<Icon color={iconsColor} name="mail" {...iconProps} />
					{override?.['email'] || contactInfo.EMAIL}
				</Typography>
			)}
		</Flex>
	);
}
